import { render, staticRenderFns } from "./applyDetail.vue?vue&type=template&id=0cde155c&scoped=true&"
import script from "./applyDetail.vue?vue&type=script&lang=ts&"
export * from "./applyDetail.vue?vue&type=script&lang=ts&"
import style0 from "./applyDetail.vue?vue&type=style&index=0&id=0cde155c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cde155c",
  null
  
)

export default component.exports